// Notenschlüssel FHSR 60
// Quelle: https://www.km-bw.de/site/pbs-bw-new/get/documents/KULTUS.Dachmandant/KULTUS/KM-Homepage/Artikelseiten%20KP-KM/1_PDFS_2016/Berufliche%20Schule/Bewertungstabelle%20f%C3%BCr%2060-%20und%2090-%20Verrechnungspunkte.pdf
export const gkFHSR60 = {
  0: 6,
  4: 5.5,
  10: 5,
  16: 4.5,
  22: 4,
  28: 3.5,
  34: 3,
  40: 2.5,
  45: 2,
  51: 1.5,
  56: 1
}

// Notenschlüssel FHSR 90
export const gkFHSR90 = {
  0: 6,
  6: 5.5,
  15: 5,
  24: 4.5,
  33: 4,
  42: 3.5,
  51: 3,
  59: 2.5,
  67: 2,
  75: 1.5,
  83: 1
}

// Notenschlüssel IHK 100 
// Quelle: https://www.lehrerfreund.de/notenschluesselrechner/form-ihk-notenschluessel
export const gkIHK100 = {
  0: 6,
  6: 5.9,
  12: 5.8,
  17: 5.7,
  23: 5.6,
  29: 5.5,
  30: 5.4,
  32: 5.3,
  34: 5.2,
  36: 5.1,
  38: 5,
  41: 4.9,
  43: 4.8,
  45: 4.7,
  47: 4.6,
  49: 4.5,
  50: 4.4,
  52: 4.3,
  54: 4.2,
  55: 4.1,
  57: 4,
  59: 3.9,
  61: 3.8,
  62: 3.7,
  64: 3.6,
  66: 3.5,
  67: 3.4,
  68: 3.3,
  70: 3.2,
  71: 3.1,
  73: 3.0,
  74: 2.9,
  76: 2.8,
  77: 2.7,
  79: 2.6,
  80: 2.5,
  81: 2.4,
  82: 2.3,
  83: 2.2,
  84: 2.1,
  85: 2,
  87: 1.9,
  88: 1.8,
  89: 1.7,
  90: 1.6,
  91: 1.5,
  92: 1.4,
  94: 1.3,
  96: 1.2,
  98: 1.1,
  100: 1
}

// Notenschlüssel Abi 60
export const gkAbi60 = {
  0: 0,
  12: 1,
  16: 2,
  20: 3,
  24: 4,
  27: 5,
  30: 6,
  33: 7,
  36: 8,
  39: 9,
  42: 10,
  45: 11,
  48: 12,
  51: 13,
  54: 14,
  57: 15
}

// Notenschlüssel Abi 90
export const gkAbi90 = {
  0: 0,
  18: 1,
  24: 2,
  30: 3,
  36: 4,
  41: 5,
  45: 6,
  50: 7,
  54: 8,
  59: 9,
  63: 10,
  68: 11,
  72: 12,
  77: 13,
  81: 14,
  86: 15
}

// Notenschlüssel Abi ab 2024 80BE
export const gkAbi24_80 = {
  0: 0,
  16: 1,
  22: 2,
  27: 3,
  32: 4,
  36: 5,
  40: 6,
  44: 7,
  48: 8,
  52: 9,
  56: 10,
  60: 11,
  64: 12,
  68: 13,
  72: 14,
  76: 15
}

// Notenschlüssel Abi ab 2024 90BE
export const gkAbi24_90 = {
  0: 0,
  18: 1,
  24: 2,
  30: 3,
  36: 4,
  41: 5,
  45: 6,
  50: 7,
  54: 8,
  59: 9,
  63: 10,
  68: 11,
  72: 12,
  77: 13,
  81: 14,
  86: 15
}

// Notenschlüssel Abi ab 2024 100BE
export const gkAbi24_100 = {
  0: 0,
  20: 1,
  27: 2,
  33: 3,
  40: 4,
  45: 5,
  50: 6,
  55: 7,
  60: 8,
  65: 9,
  70: 10,
  75: 11,
  80: 12,
  85: 13,
  90: 14,
  95: 15
}

// Notenschlüssel Abi ab 2024 120BE
export const gkAbi24_120 = {
  0: 0,
  24: 1,
  32: 2,
  40: 3,
  48: 4,
  54: 5,
  60: 6,
  66: 7,
  72: 8,
  78: 9,
  84: 10,
  90: 11,
  96: 12,
  102: 13,
  108: 14,
  114: 15
}

export function createLinearGradeStructure(max, soben, sunten, knick) {
  // console.log("MAX", max, "SOBEN", soben, "SUNTEN", sunten, "KNICK", knick);

  let bestGrade = 1;
  let worstGrade = 6;

  const gradeStructure = {};

  soben === -1 ? soben = max : soben = soben;
  sunten === -1 ? sunten = 0 : sunten = sunten;
  knick === -1 ? knick = 0 : knick = knick;

  for (let points = 0; points <= max; points += 0.5) {

    if (knick > 0) {
      if (points >= soben) {
        gradeStructure[points] = bestGrade;
      }
      else if (points <= sunten) {
        gradeStructure[points] = worstGrade;
      }
      else if (points <= knick) {
        // gradeStructure[points] = 6 - 1.6 * (points / knick);
        gradeStructure[points] = 6 - 1.6 * ((points - sunten) / (knick - sunten));
      }
      else {
        // gradeStructure[points] = 4.4 - 3.4 * ((points - knick) / (max - knick));
        gradeStructure[points] = 4.4 - 3.4 * ((points - knick) / (soben - knick));
      }
    }
    else if (points <= sunten) {
      gradeStructure[points] = worstGrade;
    }
    else if (points >= soben) {
      gradeStructure[points] = bestGrade;
    }
    else {
      // const grade = 6 - 5 * (points / max);
      const grade = 6 - 5 * ((points - sunten) / (soben - sunten));
      gradeStructure[points] = parseFloat(grade.toFixed(1));
    }
  }

  return gradeStructure;
}

export function calcMark(gk, p, max, rmp, soben = -1, sunten = -1, knick = -1) {
  let note = 6;
  // console.log("XXX", gk, p, max, rmp, soben, sunten, knick);
  // let realMaxPoints = Number(this.state.realMaxPoints);
  let realMaxPoints = rmp;
  if (realMaxPoints === NaN || realMaxPoints === undefined ||
    realMaxPoints === null || realMaxPoints === "") {
    realMaxPoints = 0;
  }
  if (gk === 1) {
    //   note = 6 - 5 * (p / max);
    // console.log("dont be so linear jean luc");

    const gkLinear = createLinearGradeStructure(max, soben, sunten, knick);

    // console.log(gkLinear);

    const sortedKeys = Object.keys(gkLinear)
      .map(k => parseFloat(k)) // Convert keys to numbers
      .sort((a, b) => a - b) // Sort numerically
      .map(k => k.toString()); // Convert back to strings

    // console.log(sortedKeys);

    // for (let key of Object.keys(gkLinear)) {

    for (let key of sortedKeys) {
      if (p >= key) {
        // console.log("p and KEY", p, key);

        note = gkLinear[key];
      }
    }
  }
  else if (gk === 2) {
    note = 0;
    if (realMaxPoints !== 0) {
      p = Math.ceil((60 / realMaxPoints) * p);
    }

    for (let key of Object.keys(gkAbi60)) {
      if (p >= key) {
        note = gkAbi60[key];
      }
    }
  }
  else if (gk === 3) {
    note = 0;
    if (realMaxPoints !== 0) {
      p = Math.ceil((90 / realMaxPoints) * p);
    }
    for (let key of Object.keys(gkAbi90)) {
      if (p >= key) {
        note = gkAbi90[key];
      }
    }
  }
  else if (gk === 4) {
    note = 0;
    for (let key of Object.keys(gkFHSR60)) {
      if (p >= key) {
        note = gkFHSR60[key];
      }
    }
  }
  else if (gk === 5) {
    note = 0;
    for (let key of Object.keys(gkFHSR90)) {
      if (p >= key) {
        note = gkFHSR90[key];
      }
    }
  }
  else if (gk === 6) {
    note = 0;
    for (let key of Object.keys(gkIHK100)) {
      if (p >= key) {
        note = gkIHK100[key];
      }
    }
  }
  else if (gk === 7) {
    // p *= 2;
    // XXX weird calc here
    note = 0;
    for (let key of Object.keys(gkAbi60)) {
      if (p >= key) {
        note = gkAbi60[key];
      }
    }
  }
  else if (gk === 8) {
    note = 0;
    if (realMaxPoints !== 0) {
      p = Math.ceil((80 / realMaxPoints) * p);
    }
    for (let key of Object.keys(gkAbi24_80)) {
      if (p >= key) {
        note = gkAbi24_80[key];
      }
    }
  }
  else if (gk === 9) {
    note = 0;
    if (realMaxPoints !== 0) {
      p = Math.ceil((90 / realMaxPoints) * p);
    }
    for (let key of Object.keys(gkAbi24_90)) {
      if (p >= key) {
        note = gkAbi24_90[key];
      }
    }
  }
  else if (gk === 10) {
    note = 0;
    if (realMaxPoints !== 0) {
      p = Math.ceil((100 / realMaxPoints) * p);
    }
    for (let key of Object.keys(gkAbi24_100)) {
      if (p >= key) {
        note = gkAbi24_100[key];
      }
    }
  }
  else if (gk === 11) {
    note = 0;
    if (realMaxPoints !== 0) {
      p = Math.ceil((120 / realMaxPoints) * p);
    }
    for (let key of Object.keys(gkAbi24_120)) {
      if (p >= key) {
        note = gkAbi24_120[key];
      }
    }
  }
  else if (gk === 12) {
    note = 0;
    if (realMaxPoints === 0) {
      p *= 3;
      realMaxPoints = 90;
    }

    p = Math.ceil((90 / realMaxPoints) * p);

    for (let key of Object.keys(gkAbi24_90)) {
      if (p >= key) {
        note = gkAbi24_90[key];
      }
    }
  }
  // console.log("NOTE", note);
  note = Math.round((note + Number.EPSILON) * 100) / 100;
  return note;
}
